function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getTmsInstance } from 'integration-web-core--socle/js/assets/commons/_tms';

/**
 * This class makes Kobi lazy-loading of fragments compatible with data TMS.
 * It listens for 'fragmentLoaded' events and push data TMS client side when a fragment is lazy-loaded.
 */
export var TmsLazyLoadingBridge = /*#__PURE__*/function () {
  function TmsLazyLoadingBridge(fragmentIdRegExp) {
    _classCallCheck(this, TmsLazyLoadingBridge);
    /**
     * A pattern matching the fragment ids that will trigger a data TMS push when lazy-loaded.
     */
    _defineProperty(this, "fragmentIdRegExp", null);
    /**
     * The current listener for the 'fragmentLoaded' event.
     */
    _defineProperty(this, "fragmentLoadedListener", null);
    this.fragmentIdRegExp = fragmentIdRegExp;
  }

  /**
   * Start listening for 'fragmentLoaded' events.
   * If the listener is already started, it does nothing.
   * @returns {boolean} true if the listener has been started.
   */
  return _createClass(TmsLazyLoadingBridge, [{
    key: "startListening",
    value: function startListening() {
      var _this = this;
      if (this.fragmentLoadedListener) {
        return false;
      }
      var lazyLoadingEventBus = window['lazy-loading-bus'];
      if (!lazyLoadingEventBus) {
        console.warn('Lazy loading event bus not found');
        return false;
      }
      this.fragmentLoadedListener = function (event) {
        return _this.handleFragmentLoadedEvent(event);
      };
      lazyLoadingEventBus.on('fragmentLoaded', this.fragmentLoadedListener);
      return true;
    }

    /**
     * Stop listening for 'fragmentLoaded' events.
     * If the listener is not started, it does nothing.
     * @returns {boolean} true if the listener has been stopped.
     */
  }, {
    key: "stopListening",
    value: function stopListening() {
      if (!this.fragmentLoadedListener) {
        return false;
      }
      var lazyLoadingEventBus = window['lazy-loading-bus'];
      if (!lazyLoadingEventBus) {
        console.warn('Lazy loading event bus not found');
        return false;
      }
      lazyLoadingEventBus.off('fragmentLoaded', this.fragmentLoadedListener);
      this.fragmentLoadedListener = null;
      return true;
    }
  }, {
    key: "handleFragmentLoadedEvent",
    value: function handleFragmentLoadedEvent(event) {
      var _event$detail = event.detail,
        fragmentId = _event$detail.fragmentId,
        htmlElements = _event$detail.htmlElements;
      if (this.fragmentIdRegExp && this.fragmentIdRegExp.test(fragmentId) && this.anyHtmlElementContainsDataTms(htmlElements)) {
        this.pushDataTmsClientSide();
      }
    }
  }, {
    key: "anyHtmlElementContainsDataTms",
    value: function anyHtmlElementContainsDataTms(htmlElements) {
      var _iterator = _createForOfIteratorHelper(htmlElements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var htmlElement = _step.value;
          if (htmlElement.querySelector(TmsLazyLoadingBridge.dataTmsSelector) !== null) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }

    /**
     * Push data TMS client side.
     * This method should be called when a fragment is lazy-loaded.
     * It reads all the DOM, searching for .dataTms elements and merge them into the existing data layer.
     */
  }, {
    key: "pushDataTmsClientSide",
    value: function pushDataTmsClientSide() {
      getTmsInstance().pushFragment([], false);
    }
  }]);
}();
/**
 * CSS selector for elements containing data TMS.
 */
_defineProperty(TmsLazyLoadingBridge, "dataTmsSelector", 'script.dataTms[type="application/json"]');
(function () {
  var tmsLazyLoadingBridge = new TmsLazyLoadingBridge(/com\.adeo\.website\.productrecommendation\..*/);
  tmsLazyLoadingBridge.startListening();
})();